import React from "react"
import Card  from "./style"

export default function PricingCard({backgroundColor,yearlyPackage, cardTitle, amount, ...rest}) {
  return (
    <Card backgroundColor="#fff" {...rest}>
        <Card.Top backgroundColor={backgroundColor}>
            <Card.Title as="h3">{cardTitle}</Card.Title>
            <Card.Text>{yearlyPackage ?"Полная стоимость":"Ежемесячно" }</Card.Text>
            <Card.Price>
            <Card.PriceText alignSelf="flex-start">UZS</Card.PriceText>
            <Card.Amount>{amount}</Card.Amount>
            <Card.PriceTextTwo>,000</Card.PriceTextTwo>
            </Card.Price>
        </Card.Top>
        <Card.List pt="40px">
            <Card.ListItem>Advanced Python</Card.ListItem>
            <Card.ListItem>Architecture</Card.ListItem>
            <Card.ListItem>Patterns</Card.ListItem>
            <Card.ListItem>Databases</Card.ListItem>
        </Card.List>
        <Card.Box>
          <a href="/about/contact">
            <Card.Button textColor="#fff" hoverTextColor="#fff" backgroundColor={backgroundColor}  hoverBackgroundColor={backgroundColor} rounded={true} sizeX="180px" sizeY="56px" rounded="true">Записаться</Card.Button>
          </a>
        </Card.Box>
    </Card>
    
  )
}
